var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2864 6.58732C11.2215 6.47166 11.0993 6.4 10.9666 6.4H8.43184L8.76539 2.3972C8.77935 2.22963 8.67748 2.07407 8.51832 2.01983C8.35988 1.96522 8.18354 2.02629 8.09221 2.16755L4.05893 8.4008C3.98587 8.5136 3.98033 8.65733 4.04461 8.7753C4.10889 8.89328 4.23241 8.96666 4.36668 8.96666H6.90396L6.56773 13.3385C6.55467 13.5075 6.65921 13.6635 6.82052 13.7156C6.85776 13.7276 6.89571 13.7333 6.93332 13.7333C7.05828 13.7333 7.17823 13.6691 7.24627 13.5579L11.2795 6.95795C11.3487 6.84481 11.3513 6.70298 11.2864 6.58732ZM7.41583 11.8738L7.66557 8.62816C7.67346 8.52629 7.63837 8.42583 7.56907 8.3508C7.49961 8.27597 7.40203 8.23333 7.29999 8.23333H5.04075L7.913 3.79422L7.66791 6.7363C7.6595 6.83853 7.69406 6.93945 7.76352 7.01501C7.83298 7.09041 7.93072 7.13333 8.03332 7.13333H10.3128L7.41583 11.8738Z",
    fill: "#434343",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.6aea9f1b3ca99b885a39d1e903876a54.svg";
export { ForwardRef as ReactComponent };